import { Download } from 'lucide-react';
import { useState, type ReactNode } from 'react';
import { saveBlob } from '@/lib/download';

/** Fetches a file on click and saves it; a failed download says so next to the button instead of doing nothing. */
export function DownloadButton({
  load,
  name,
  className = 'btn-ghost size-8 px-0',
  label,
  children,
}: {
  load: () => Promise<Blob>;
  name: string;
  className?: string;
  label?: string;
  children?: ReactNode;
}) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string>();
  const run = async () => {
    setBusy(true);
    setError(undefined);
    try {
      saveBlob(await load(), name);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Не удалось скачать файл');
    } finally {
      setBusy(false);
    }
  };
  return (
    <>
      <button type="button" className={className} aria-label={label ?? `Скачать ${name}`} onClick={run} disabled={busy}>
        {children ?? <Download className="size-4" />}
      </button>
      {error && (
        <span role="alert" className="text-xs text-overdue">
          {error}
        </span>
      )}
    </>
  );
}
